<div class="text-center bg-white" *ngIf="loading && !documentsLoaded">
  <div class="container-fluid py-3 px-2 tab-content-border">
    <i class="fas fa-spinner fa-pulse fa-3x"></i>
  </div>
</div>
<div *ngIf="documentsLoaded || !loading">
  <div class="container-fluid py-3 bg-white px-2 tab-content-border">
    <div class="text-center text-muted small mb-2" *ngIf="loading && documentsLoaded">
      <i class="fas fa-spinner fa-pulse"></i>
      Loading documents...
    </div>
    <div class="row my-2 mx-2">
      <div class="col-lg-6 col-xl-7">
        <div class="form-group">
          <label>Document Type</label>
          <div class="document-type-filter">
            <div class="input-group input-group-sm mb-2">
              <input
                #documentTypeFilterInput
                type="text"
                class="form-control"
                placeholder="Filter document types"
                autocomplete="off"
                autocorrect="off"
                spellcheck="false"
                (keydown.enter)="applyDocumentTypeFilter(documentTypeFilterInput.value); $event.preventDefault()"
              />
              <div class="input-group-append">
                <button type="button" class="btn btn-outline-secondary" (click)="applyDocumentTypeFilter(documentTypeFilterInput.value)">
                  Apply
                </button>
                <button type="button" class="btn btn-outline-secondary" *ngIf="documentTypeFilterText" (click)="documentTypeFilterInput.value = ''; clearDocumentTypeFilter()">
                  Clear Text
                </button>
                <button type="button" class="btn btn-outline-secondary" *ngIf="selectedDocumentTypeCount() > 0" (click)="clearDocumentTypeSelection()">
                  Clear {{ selectedDocumentTypeCount() }}
                </button>
              </div>
            </div>
            <div class="document-type-groups">
              <ng-container *ngTemplateOutlet="documentTypeNodesTemplate; context: { nodes: documentTypeVisibleTree, level: 0 }"></ng-container>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-xl-5">
        <div class="text-center">
          <pagination
            class="pagination-sm text-center justify-content-center"
            (pageChanged)="loadDocuments($event)"
            [boundaryLinks]="true"
            [totalItems]="count"
            [maxSize]="5"
            [(ngModel)]="search_params.page"
            [itemsPerPage]="search_params.per_page"
            previousText="&lsaquo;"
            nextText="&rsaquo;"
            firstText="&laquo;"
            lastText="&raquo;"
          ></pagination>
        </div>
        <div class="form-group document-author-filter">
          <label>Author</label>
          <select class="form-control" [(ngModel)]="search_params.document_author_id">
            <option *ngFor="let document_author of search_options.document_authors" [value]="document_author.value">{{ document_author.label }}</option>
          </select>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Tags</label>
              <select class="form-control" multiple="true" [(ngModel)]="search_params.tags">
                <option *ngFor="let tag of search_options.tags" [value]="tag">{{ tag }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Content</label>
              <textarea class="form-control" [(ngModel)]="search_params.content"></textarea>
            </div>
          </div>
        </div>
        <div class="text-center document-count">
          <label>Number of documents</label>
          <p>{{ count }}</p>
        </div>
        <div class="custom-control custom-checkbox text-right small">
          <input
            id="show-email-thread-sources"
            type="checkbox"
            class="custom-control-input"
            [(ngModel)]="search_params.show_email_thread_sources"
            (change)="search_params.page = 1; loadDocuments()"
          />
          <label class="custom-control-label" for="show-email-thread-sources">Show email source files</label>
        </div>
      </div>
    </div>
    <div class="row my-2 mx-2">
      <div class="col-sm-4">
        <div *ngIf="selectedDocumentsCount > 0">
          <app-badge badgeType="secondary">&nbsp;{{ selectedDocumentsCount }} selected&nbsp;</app-badge>
          &nbsp;
          <button type="button" class="btn btn-danger" [disabled]="processingBulkDeletion" (click)="processBulkDeletion()">
            <span *ngIf="!processingBulkDeletion"> Delete selected </span>
            <span *ngIf="processingBulkDeletion"> {{ processBulkDeletionText || 'Deleting selected' }} <i *ngIf="processingBulkDeletion" class="fas fa-spinner fa-pulse"></i> </span>
          </button>
        </div>
      </div>
      <div class="col-sm-4 mr-auto text-center">
        <button type="button" class="btn btn-primary" [disabled]="loading" (click)="searchDocuments(false)">Search</button>
        <button type="button" class="btn btn-outline-primary ml-2" [disabled]="loading" (click)="searchDocuments(true)">Exclude</button>
        <button type="button" class="btn btn-outline-secondary ml-2" (click)="clearFilters()">
          <i class="fas fa-times mr-1"></i>
          Clear Filters
        </button>
      </div>
    </div>
    <table class="table table-striped" style="font-size: 80%">
      <thead>
        <tr>
          <th>
            <div class="custom-control custom-checkbox" (click)="selectedAll = !selectedAll; selectAll()">
              <input name="is_priority" type="checkbox" class="custom-control-input" [(ngModel)]="selectedAll" [checked]="selectedAll" />
              <label class="custom-control-label"></label>
            </div>
          </th>
          <th>
            <button 
              type="button" 
              [ngClass]="{ 'text-primary font-weight-bold': search_params.sort_type == 'Type' }" 
              class="btn btn-link btn-sm" 
              (click)="loadDocuments(null, 'Type')">
              Type&nbsp;
              <i class="fas" [ngClass]="{ 'fa-long-arrow-alt-down': this.sortSettings['Type'] == 'asc', 'fa-long-arrow-alt-up': this.sortSettings['Type'] != 'asc' }"></i>
            </button>
          </th>
          <th>
            <button 
              type="button" 
              [ngClass]="{ 'text-primary font-weight-bold': search_params.sort_type == 'Created' }"  
              class="btn btn-link btn-sm" 
              (click)="loadDocuments(null, 'Created')">
              Created&nbsp;
              <i class="fas" [ngClass]="{ 'fa-long-arrow-alt-down': this.sortSettings['Created'] == 'asc', 'fa-long-arrow-alt-up': this.sortSettings['Created'] != 'asc' }"></i>
            </button>
          </th>
          <th>
            <button 
              type="button" 
              [ngClass]="{ 'text-primary font-weight-bold': search_params.sort_type == 'Authored' }"  
              class="btn btn-link btn-sm" 
              (click)="loadDocuments(null, 'Authored')">
              Authored&nbsp;
              <i class="fas" [ngClass]="{ 'fa-long-arrow-alt-down': this.sortSettings['Authored'] == 'asc', 'fa-long-arrow-alt-up': this.sortSettings['Authored'] != 'asc' }"></i>
            </button>
          </th>
          <th>
            <button 
              type="button" 
              [ngClass]="{ 'text-primary font-weight-bold': search_params.sort_type == 'Authors' }"  
              class="btn btn-link btn-sm" (click)="loadDocuments(null, 'Authors')">
              Authors&nbsp;
              <i class="fas" [ngClass]="{ 'fa-long-arrow-alt-down': this.sortSettings['Authors'] == 'asc', 'fa-long-arrow-alt-up': this.sortSettings['Authors'] != 'asc' }"></i>
            </button>
          </th>
          <th>
            <button 
              type="button" 
              [ngClass]="{ 'text-primary font-weight-bold': search_params.sort_type == 'Name' }"  
              class="btn btn-link btn-sm" (click)="loadDocuments(null, 'Name')">
              Name&nbsp;
              <i class="fas" [ngClass]="{ 'fa-long-arrow-alt-down': this.sortSettings['Name'] == 'asc', 'fa-long-arrow-alt-up': this.sortSettings['Name'] != 'asc' }"></i>
            </button>
          </th>
          <th>
            <button type="button" class="btn btn-link btn-sm" disabled="true">Pages</button>
          </th>
          <th>
            <button type="button" class="btn btn-link btn-sm" disabled="true">Status</button>
          </th>
          <th>
            <button type="button" class="btn btn-link btn-sm" disabled="true">Notes</button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let document of documents">
          <td>
            <div class="custom-control custom-checkbox" (click)="document.selected = !document.selected; selectedAll = false; updateSelectedCount()">
              <input name="is_priority" type="checkbox" class="custom-control-input" [(ngModel)]="document.selected" [checked]="document.selected" />
              <label class="custom-control-label"></label>
            </div>
          </td>
          <td>{{ document.document_type }}</td>
          <td style="max-width: 100px !important" [title]="document.created_at_3">{{ document.created_at }}</td>
          <td style="max-width: 100px !important" [title]="document.authored_at_3">{{ document.authored_at }}</td>
          <td>
            <div *ngFor="let author of document.authors">{{ author }}</div>
          </td>
          <td>
            <div class="btn-group btn-group-sm document-actions" role="group">
              <a class="btn btn-link" title="View document" href="javascript: void(0)" (click)="loadDocument(document)"><i class="far fa-folder-open"></i></a>
              <a class="btn btn-link" title="Edit document" [href]="document.v1_url + '/edit'" *ngIf="document.v1_url && document.file_present && matterStoreService.documentEditor"><i class="fas fa-pencil-alt"></i></a>
              <a class="btn btn-link" title="Edit document" href="javascript: void(0)" *ngIf="!document.v1_url && (document.is_editable || !document.uploaded) && matterStoreService.documentEditor" (click)="editDocument(document.id, true)"><i class="fas fa-pencil-alt"></i></a>
              <a class="btn btn-link" title="Convert PDF to Word" href="javascript:void(0)" *ngIf="document.is_pdf && (document.file_present || !document.uploaded) && !document.word_conversion_processing" (click)="convertToWord(document)">
                <span class="word-conversion-icon" aria-hidden="true">W</span><span class="sr-only">Convert PDF to Word</span>
              </a>
              <span class="btn btn-link" *ngIf="document.word_conversion_processing" title="Converting PDF to Word..."><i class="fas fa-spinner fa-spin text-info"></i></span>
              <a class="btn btn-link" title="Run text recognition (OCR)" href="javascript:void(0)" *ngIf="document.needs_ocr && !document.ocr_done && !document.ocr_processing" (click)="ocrDocument(document)"><i class="fas fa-font"></i></a>
              <span class="btn btn-link" *ngIf="document.ocr_processing" title="Running OCR..."><i class="fas fa-spinner fa-spin text-info"></i></span>
              <span class="btn btn-link text-success" *ngIf="document.ocr_done" title="OCR complete"><i class="fas fa-check"></i></span>
            </div>
            <div class="document-name">
              <span *ngIf="!document.file_present && document.uploaded">
              <span *ngIf="document.name && document.name.length > 20">{{ document.short_name }}</span>
              <span *ngIf="document.name && document.name.length <= 20">{{ document.name }}</span>
              </span>
              <button type="button" class="btn btn-link btn-sm" *ngIf="document.file_present || !document.uploaded" (click)="downloadDocument($event, document.id)" style="padding: 0; border: none; background: none; color: #007bff; cursor: pointer; text-decoration: none;"
              [title]="(document.document_type ? document.document_type : '') + (document.document_type && document.notes ? ' — ' : '') + (document.notes ? document.notes : '')">
                <span *ngIf="document.name && document.name.length > 20">{{ document.short_name }}</span>
                <span *ngIf="document.name && document.name.length <= 20">{{ document.name }}</span>
              </button>
            </div>
            <span *ngIf="document.autosaved"><br />(Autosaved)</span>
            <span *ngIf="!document.file_present && document.uploaded" class="text-warning"><br />(File missing)</span>
            <div *ngIf="document.email_thread_document && document.thread_message_count > 1" class="small text-muted mt-1">
              {{ document.thread_message_count }} messages
              <a
                *ngIf="document.thread_root_history_id"
                class="ml-2"
                [href]="'/matters/' + matter_id + '?history_id=' + document.thread_root_history_id"
              >Open thread</a>
            </div>
          </td>
          <td>{{ document.page_count }}</td>
          <td>{{ document.status }}</td>
          <td style="width: 27.77777777% !important">{{ document.notes }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<ng-template #documentTypeNodesTemplate let-nodes="nodes" let-level="level">
  <div class="document-type-node" *ngFor="let node of nodes" [style.paddingLeft.px]="level * 14">
    <div class="document-type-group-header">
      <button
        type="button"
        class="btn btn-link btn-sm p-0 text-left document-type-expand-button"
        [class.invisible]="documentTypeArray(node.children).length < 1"
        (click)="documentTypeGroupsExpanded[node.key] = !documentTypeGroupsExpanded[node.key]"
      >
        <i class="fas" [ngClass]="{ 'fa-chevron-down': documentTypeNodeExpanded(node), 'fa-chevron-right': !documentTypeNodeExpanded(node) }"></i>
      </button>
      <div class="document-type-checkbox-row">
        <input
          type="checkbox"
          class="document-type-native-checkbox"
          [checked]="documentTypeNodeSelected(node)"
          (change)="setDocumentTypeNodeFromEvent(node, $event)"
          [indeterminate]="documentTypeNodePartiallySelected(node)"
        />
        <span class="document-type-label">
          {{ node.name }}
          <span class="document-type-prefix text-muted" *ngIf="documentTypeDisplayPrefix(node) as prefix">{{ prefix }}</span>
          <span class="text-muted">({{ node.count }})</span>
        </span>
      </div>
    </div>
    <ng-container *ngIf="documentTypeArray(node.children).length > 0 && documentTypeNodeExpanded(node)">
      <ng-container *ngTemplateOutlet="documentTypeNodesTemplate; context: { nodes: documentTypeArray(node.children), level: level + 1 }"></ng-container>
    </ng-container>
  </div>
</ng-template>
